import { Reminder } from '@griply/types';
import { ScheduleFrequency } from 'shared/types/habit-schedule';
import { ID } from 'shared/types/id';
import { TaskPriorityOptions } from 'shared/types/task-base';

export type Person = { id: ID; name: string };

export type ParsedProperties = {
  goal?: ID | null;
  lifeArea?: ID | null;
  tags?: ID[];
  assignees?: ID[] | null;
  dueDate?: Date | null;
  deadline?: Date | null;
  priority?: TaskPriorityOptions | null;
  startTime?: number | null; // in milliseconds
  duration?: number | null; // in milliseconds
  reminders?: Reminder[] | null;
  rrule?: string | null;
  target?: ScheduleFrequency | null;
};

export enum NewEntityTypes {
  Goal = 'goal',
  Tag = 'tag',
  Person = 'person',
}

export enum SuggestionTriggers {
  LinkedItem = '~',
  Tag = '#',
  Person = '@',
}
